export default __webpack_public_path__ + "static/media/3.99a905e5.jpeg";